module.exports = __webpack_public_path__ + "static/media/modalVideo.4b1076fc.png";